import React from 'react';
import { FaApple, FaWhatsapp, FaInstagram } from 'react-icons/fa';
import { SiSamsung } from 'react-icons/si';

export const AppleLogo: React.FC<React.SVGProps<SVGSVGElement>> = (props) => (
    <FaApple {...props} />
);

export const WhatsAppIcon: React.FC<React.SVGProps<SVGSVGElement>> = (props) => (
    <FaWhatsapp {...props} />
);

export const InstagramIcon: React.FC<React.SVGProps<SVGSVGElement>> = (props) => (
    <FaInstagram {...props} />
);

export const SamsungLogo: React.FC<React.SVGProps<SVGSVGElement>> = (props) => (
    <SiSamsung {...props} />
);
